module.exports = __webpack_public_path__ + "static/media/article_number.2fb1e461.jpeg";